import graph from "@irati/utils/services/graph"
import {ScheduledTransferStatus} from "@irati/types"
import {toString as ScheduledTransfersQuery} from "./query/ScheduledTransferList"

const service = {
  list: (
    walletOwnerId: string,
    walletId: string,
    scheduledTransferStatus: ScheduledTransferStatus[],
    cursor: string | null = null,
    limit: number = 15,
    options: any = {}
  ) => {
    return graph(
      {query: ScheduledTransfersQuery, variables: {walletOwnerId, walletId, scheduledTransferStatus, cursor, limit}},
      options
    ).then((response) => response.scheduledTransfers)
  }
}

export const getScheduledTransfers = service.list
